import { DefaultResType } from "../../types/common/response";
import { baseApi } from "../../util/axiosConfig";

const url = "api/auth/";

export async function loginApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "login", data );
  } catch (err: any) {
    return err?.response;
  }
}

export async function logoutApi(): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "logout");
  } catch (err: any) {
    return err?.response;
  }
}

export async function resetPasswordApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "reset_password", data );
  } catch (err: any) {
    return err?.response;
  }
}

export async function sendPasswordResetEmailApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "send_password_reset_email", data );
  } catch (err: any) {
    return err?.response;
  }
}